import React from 'react';

function SearchIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path id="Vector" d="M19.8,18.7L15,13.9c1.4-1.7,2.1-3.8,1.9-6c-0.1-2.2-1.1-4.2-2.7-5.7C12.6,0.7,10.4,0,8.3,0C6.1,0.1,4,0.9,2.5,2.5S0.1,6.1,0,8.3c0,2.2,0.7,4.3,2.2,5.9s3.5,2.6,5.7,2.7c2.2,0.1,4.3-0.5,6-1.9l4.8,4.8c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.2c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3C19.9,18.8,19.8,18.8,19.8,18.7z M1.6,8.5c0-1.4,0.4-2.7,1.2-3.8s1.8-2,3.1-2.5s2.7-0.7,4-0.4c1.3,0.3,2.6,0.9,3.5,1.9c1,1,1.6,2.2,1.9,3.5c0.3,1.3,0.1,2.7-0.4,4c-0.5,1.3-1.4,2.3-2.5,3.1c-1.1,0.8-2.5,1.2-3.8,1.2c-1.8,0-3.6-0.7-4.9-2C2.3,12.1,1.6,10.3,1.6,8.5z"/>
      </g>
    </svg>
  );
}

export default SearchIcon;
